import { useState, useEffect } from 'react';
import './LFinalCTA.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular
import { Link } from 'react-router-dom';

function LFinalCTA() {
  return (
    <section className="final-cta">
      <div className="lp-container">
        <div className="final-cta-box">
          {/* Intense Ambient Glow */}
          <div className="fcta-glow"></div>
          
          <h2 className="final-cta-title">Inicia Freemium 7 Días y Prueba el Poder de Spacy</h2>
          <p className="final-cta-subtitle">
            Desbloquea una experiencia inmersiva impulsada por IA. Lo que te espera:
          </p>
          
          <div className="fcta-features">
            <div className="fcta-feat">
              <span className="fcta-icon">🤖</span>
              <div><strong>Spacy Tutor:</strong> Habla y corrige en tiempo real con IA avanzada.</div>
            </div>
            <div className="fcta-feat">
              <span className="fcta-icon">🧠</span>
              <div><strong>Mentes Brillantes:</strong> Debates y charlas con figuras históricas.</div>
            </div>
            <div className="fcta-feat">
              <span className="fcta-icon">🎮</span>
              <div><strong>Minigames y Cine:</strong> Diviértete y aprende con NeuraCinema.</div>
            </div>
          </div>
          
          <Link to="/register" className="hero-cta fcta-btn">
            Empieza tu Prueba GRATIS Ahora
          </Link>
          
          <p className="cta-footer-notes">
            ✔ Sin tarjeta de crédito &nbsp;&nbsp; ✔ Cancela cuando quieras &nbsp;&nbsp; ✔ Acceso inmediato
          </p>
        </div>
      </div>
    </section>
  );
}

export default LFinalCTA;